import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

export const getAvailablePhoneNumbers = async (): Promise<string[]> => {
  const endpointURL = getSportingServiceURL('getAvailablePhoneNumbers');

  const headers = createSportingHeaders();

  const response = await customFetch(endpointURL, { headers });

  if (response.ok) {
    return response.json();
  } else {
    throw new UnexpectedError();
  }
};
